<template>
  <div class="maskBox">
    <div class="NoSpinChancesYet">
      <div class="title">{{$t('lang.cashWheel.youGetThreeSpinChance')}}</div>
      <div class="title">{{ getYouGetThreeSpinChance2($t('lang.cashWheel.youGetThreeSpinChance2')) }}</div>
      <div class="chanceBox">
        <slot>
          <!--        <img src="../../assets/images/cashWheel/chanceIcon.png" class="chanceIcon" alt="">-->
          <!--        <div class="chanceNum">X{{chanceNum}}</div>-->
        </slot>
      </div>
      <div class="tip">{{$t('lang.cashWheel.goTryYourLuck')}}</div>
      <div class="Btn" @click="close">{{$t('lang.cashWheel.get')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modalBox-getChance',
  props: {
    'chanceNum': {
      type: Number,
      default: 0
    }
  },
  data () {
    return {}
  },
  methods: {
    getYouGetThreeSpinChance2 (text) {
      if (this.chanceNum === 3) {
        return text.replace('{num}', this.$t('lang.cashWheel.three'))
      } else {
        return text.replace('{num}', this.$t('lang.cashWheel.one'))
      }
    },
    close () {
      this.$emit('closeModalBoxGetChance', this.chanceNum)
    }
  }
}
</script>

<style lang="less" scoped>
.maskBox{
  height: 100vh;
  width: 100%;
  position: fixed;
  background-color: rgba(0,0,0,0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
@keyframes expandBox {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.NoSpinChancesYet{
  width: 82.233vw;
  height: 66.94vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 9999;
  animation: expandBox 0.2s ease-in-out forwards;
  border: 1px solid #888888;
  border-right: 2px solid #888888;
  border-left: 2px solid #888888;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 1.243vw;
  .title{
    width: 50.27vw;
    color: #D9D9D9;
    font-size: 5.277vw;
    font-weight: 700;
    text-align: center;
    position: relative;
    top: 3vw;
  }
  .Btn{
    width: 65.913vw;
    height: 10.833vw;
    background: linear-gradient(90deg, #01B7D3 0%, #13C498 100%), #F1DAB0;
    border-radius: 1.388vw;
    color: #000000;
    font-size: 4.44vw;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: 12vw;
  }
  .chanceBox{
    height: 21.388vw;
    width: 21.388vw;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(8px);
    color: #fff;
    border-radius: 1.5vw;
    position: relative;
    top: 6vw;
    display: flex;
    align-items: center;
    justify-content: center;
    .chanceIcon{
      height: 20vw;
      width: 20vw;
    }
    .chanceNum{
      position: absolute;
      left: 15vw;
      top: 16vw;
      font-size: 3vw;
      color: #fff;
      font-weight: 700;
    }
  }
  .tip{
    font-size: 3.61vw;
    color: #DFDFDF;
    position: relative;
    top: 9vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cashWheel/modalBox-getChance.vue